import {
  CULTURAL_CREATE_CATEGORY_REQUEST,
  CULTURAL_CREATE_CATEGORY_SUCCESS,
  CULTURAL_CREATE_CATEGORY_FAIL,
} from "../actionTypes";

const initialState = {
  loading: false,
  category: [],
  error: null,
};

const culturalCreateCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case CULTURAL_CREATE_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case CULTURAL_CREATE_CATEGORY_SUCCESS:
      return { ...state, loading: false, category: action.payload };
    case CULTURAL_CREATE_CATEGORY_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default culturalCreateCategoryReducer;
